import axios from 'axios';

export default {
  async FETCH_DATA({ commit, state }) {
    commit('FETCH_DATA_PENDING');

    let {
      stages, matches, teams, players,
    } = state;
    if (!stages.length) {
      const stagesResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/stages/all.json`);
      stages = stagesResponse.data;
    }
    if (!matches.length) {
      const matchesResponse = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/matches/all.json`,
      );
      matches = matchesResponse.data;
    }
    if (!teams.length) {
      const teamsResponse = await axios.get(`${process.env.VUE_APP_API_BASE_URL}/teams/all.json`);
      teams = teamsResponse.data;
    }
    if (!players.length) {
      const playersResponse = await axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/players/all.json`,
      );
      players = playersResponse.data;
    }

    commit('FETCH_DATA_SUCCESS', {
      stages,
      matches,
      teams,
      players,
    });
  },
};
